module.exports = __webpack_public_path__ + "img/world_amphibia.726e6213.png";